import { createAccessControlProvider } from '@frontend/components/agromarket/core/access-control'
import { HARVEST_SALE_ACCESS_CONTROL_LIST } from './constants'
import type { THarvestSaleAccessControlContext, THarvestSaleAccessControlList } from './types'

export const { AccessControlProvider: HarvestSaleAccessControlProvider, useAccessControl: useHarvestSaleAccessControl } =
  createAccessControlProvider<THarvestSaleAccessControlList, THarvestSaleAccessControlContext>(HARVEST_SALE_ACCESS_CONTROL_LIST)
